import React, { useContext } from 'react';
import ConsentCard from './ConsentCard';
import FiuConsentCard from './FiuConsentCard';
import { UserContext } from '../context/UserContext';

const ConsentList = ({
	consents,
	selectedAccounts,
	onSelectAccount,
	onViewDetails,
	customDetails,
	fiuParam,
	mobileNumber,
}) => {
	const userContext = useContext(UserContext);
	const isFip = userContext.isFip;
	return (
		<div >
			{consents.map((consent, index) => {
				const commonProps = {
					key: index,
					consent,
					isSelected: selectedAccounts
						.map((elm) => elm?.consentIntentId)
						.includes(consent.consentIntentId),
					onSelect: onSelectAccount,
					onViewDetails,
					customDetails,
					selectedAccounts,
					fiuParam,
					mobileNumber,
				};

				return isFip ? (
					<ConsentCard {...commonProps} />
				) : (
					<FiuConsentCard {...commonProps} />
				);
			})}
		</div>
	);
};

export default ConsentList;
